// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d-n_","colBig":"styles_colBig__SkWI8","colSmall":"styles_colSmall__3f6EZ","shopifyNameWrapper":"styles_shopifyNameWrapper__W_WZL"};